import { apiClient } from '@/services/ApiClient.js'

export default {
  getSubCategories(categoryId) {
    return apiClient
      .get('categories/' + categoryId + '/sub-categories')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getAllSubCategories() {
    return apiClient
      .get('sub-categories')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSubCategory(categoryId, id) {
    return apiClient
      .get('categories/' + categoryId + '/sub-categories/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editSubCategory(categoryId, id, subCategory) {
    return apiClient
      .patch('categories/' + categoryId + '/sub-categories/' + id, subCategory)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createSubCategory(categoryId, subCategory) {
    return apiClient
      .post('categories/' + categoryId + '/sub-categories/', subCategory)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getProducts(id) {
    return apiClient
      .get('sub-categories/' + id + '/products')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
